import React from 'react'
import { Key, Users, Copy, Lock, FaceID } from '@/assets/icons'

export interface SecurityAction {
  id: string
  titleKey: string
  icon: React.ComponentType<{ size?: number; color?: string }>
  route?: string
  link?: string
  action?: () => void
  visible: boolean
  iconColor?: string
  iconBgColor?: string
}

// Check if device supports biometric authentication (for web - check if it's iOS/macOS with Touch ID/Face ID)
const isBiometricSupported = () => {
  // For web app, we can check if it's Safari on iOS/macOS
  const userAgent = navigator.userAgent
  const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent)
  const isMacOS = /Macintosh/.test(userAgent)

  // Only show Face ID option for iOS devices or macOS with Safari
  return isIOSDevice || (isMacOS && /Safari/.test(userAgent))
}

const handleOpenBiometricSettings = () => {
  // For web, we can suggest users to enable biometric authentication in their browser settings
  alert(
    'Please enable biometric authentication in your browser settings or device settings.',
  )
}

const securityActions: Omit<SecurityAction, 'id'>[] = [
  {
    titleKey: 'screens:security.items.changeYourPassword',
    icon: Key,
    route: '/security/create-new-password',
    visible: true,
    iconColor: '#FFFFFF',
    // iconBgColor: '#6366F1',
  },
  {
    titleKey: 'screens:security.items.blockedUsers',
    icon: Users,
    route: '/security/blocked-users',
    visible: true,
    iconColor: '#FFFFFF',
    // iconBgColor: '#EF4444',
  },
  {
    titleKey: 'screens:security.items.requestYourData',
    icon: Copy,
    route: '/security/request-your-data',
    visible: true,
    iconColor: '#FFFFFF',
    // iconBgColor: '#10B981',
  },
  {
    titleKey: 'screens:security.items.privacyPolicy',
    icon: Lock,
    link: 'https://kemapp.io/policies/privacy-policy', // TODO: Update with actual privacy policy link
    visible: true,
    iconColor: '#FFFFFF',
    // iconBgColor: '#F59E0B',
  },
  {
    titleKey: 'screens:security.items.enableFaceID',
    icon: FaceID,
    action: handleOpenBiometricSettings,
    visible: isBiometricSupported(),
    iconColor: '#FFFFFF',
    // iconBgColor: '#8B5CF6',
  },
]

export const securityActionsList = securityActions.map((action, index) => ({
  id: index.toString(),
  ...action,
}))
